<div
  class="warningBox"
  [class.warningBox--warning]="ppLevel === 'warning'"
  [class.warningBox--error]="ppLevel === 'error'"
  [class.warningBox--info]="ppLevel === 'info'"
>
  <pp-icon [ppSVG]="iconMap[ppIconPath]" ppColor="inherit" ppClass="setSize18"></pp-icon>

  <section class="warningBox__text">
    {{ ppOpeningMessageKey | ppTranslate }}
    @for (warning of ppWarningMessages; track warning) {
      <span>{{ warning }}</span>
    }
    {{ ppClosingMessageKey | ppTranslate }}
  </section>
</div>
